import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Select from "react-select";

//------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../common/Constant";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../DatePicker/CommonDatePicker";

function SupplierEditData({ supplierID, supplierAccount }) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perPageSize, setperPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [searchtext, setSearchText] = useState("");
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedReceivingCheckboxIds, setselectedReceivingCheckboxIds] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [newTitle, setNewTitle] = useState("");
  const [startingDate, setStartingDate] = useState(moment().format('YYYY-MM-DD'));
  const [endingDate, setEndingDate] = useState(moment().format('YYYY-MM-DD'));
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "Last 7 Day " ,value: 7
    
  });
  const [customStartingDate, setCustomStartingDate] = useState(moment().format('YYYY-MM-DD'));
  const [customEndingDate, setCustomEndingDate] = useState(moment().format('YYYY-MM-DD'));

  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");

  const [receivingTypeValue, setreceivingTypeValue] = useState(0);
  const [rectype, setRectype] = useState([
    {
      ID: Number,
      SalesType: String,
    },
  ]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const [nemultiselect, setnemultiselect] = useState({
    ReceivingType: []
  });

  const today = moment().format("YYYY-MM-DD");

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "27px",
  //     position: "relative",
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //   }),
  // };

  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  console.log(supplierAccount, "supplierAccount");

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingDate,
    endingDate,
    receivingTypeValue,
    supplierID,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    status
  ) => {
    setLoading(true);
    console.log(receivingTypeValue, "receivingTypeValue");
    receivingTypeValue = receivingTypeValue > 0 ? receivingTypeValue : 0;
    supplierID = supplierID > 0 ? supplierID : 0;

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    if (supplierAccount == 6) {
      axios
        .get(
          `${
            config.suppliersBaseUrl
          }/suppliers/supplierstoreaccountlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&startdate=${
            startingDate === undefined ? "" : startingDate
          }&enddate=${
            endingDate === undefined ? "" : endingDate
          }&supplierid=${supplierID}&LocationID=${locationId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "data 123");
          setData(res.data.ResponseData);
          const data = res.data.ResponseData;
          setnemultiselect({
            ReceivingType: [
              ...new Set(data?.map((item) => item?.ReceivingType)),
            ]
          });
          setTotalRows(res.data.ResponseData[0]?.TotalRecord);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      axios
        .get(
          `${
            config.receivingBaseUrl
          }/receivings/transactionlistsupplier?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
            sorting[0]?.desc === undefined
              ? "desc"
              : sorting[0]?.desc === true
              ? "desc"
              : "asc"
          }&ordercolumn=${sorting[0]?.id ?sorting[0]?.id : "ID"}&pagesize=${
            pagination.pageSize
          }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
            globalFilter === undefined ? "" : globalFilter
          }&startdate=${
            quickBookOptions?.value === 1 ? "" : startingDate
          }&enddate=${
            quickBookOptions?.value === 1 ? "" : endingDate
          }&receivetypeid=${receivingTypeValue}&supplierid=${supplierID}&LocationID=${locationId}&status=${
            status == undefined ? 0 : status
          }`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "data 123");
          setData(res.data.ResponseData);
          setTotalRows(res.data.ResponseData[0]?.TotalRecords);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  // const handleListData = (
  //   pagenumber,
  //   pagesize,
  //   filtertext,
  //   ordercolumn,
  //   currentorder,
  //   startingDate,
  //   endingDate,
  //   receivingTypeValue,
  //   supplierID,
  //   columnFilters,
  //   globalFilter,
  //   pagination,
  //   sorting
  // ) => {
  //   setLoading(true);
  //   console.log(receivingTypeValue, "receivingTypeValue");
  //   receivingTypeValue = receivingTypeValue > 0 ? receivingTypeValue : 0;
  //   supplierID = supplierID > 0 ? supplierID : 0;

  //   const columnIndex = columns.findIndex(
  //     (column) => column.accessorKey === sorting[0]?.id
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters;

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   if (supplierAccount == 6) {
  //     axios
  //       .get(
  //         `${config.suppliersBaseUrl}/suppliers/supplierstoreaccountlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //           sorting[0]?.desc === undefined
  //             ? "desc"
  //             : sorting[0]?.desc === true
  //             ? "desc"
  //             : "asc"
  //         }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //           pagination.pageSize
  //         }&pagenumber=${
  //           pagination.pageIndex + 1
  //         }&filtertext=${globalFilter=== undefined ? "":globalFilter}&startdate=${startingDate===undefined?"":startingDate}&enddate=${endingDate===undefined?"":endingDate}&supplierid=${supplierID}&LocationID=${locationId}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         console.log(res.data.ResponseData, "data 123");
  //         setData(res.data.ResponseData);
  //         setTotalRows(res.data.ResponseData[0]?.TotalRecord);
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //       });
  //   } else {
  //     axios
  //       .get(
  //         `${config.receivingBaseUrl}/receivings/listofalldata?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //           sorting[0]?.desc === undefined
  //             ? "desc"
  //             : sorting[0]?.desc === true
  //             ? "desc"
  //             : "asc"
  //         }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
  //           pagination.pageSize
  //         }&pagenumber=${
  //           pagination.pageIndex + 1
  //         }&filtertext=${globalFilter=== undefined ? "":globalFilter}&status=0&startdate=${startingDate===undefined?"":startingDate}&enddate=${endingDate===undefined?"":endingDate}&receivingtypeid=${receivingTypeValue}&supplierid=${supplierID}&LocationID=${locationId}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         console.log(res.data.ResponseData, "data 123");
  //         setData(res.data.ResponseData);
  //         setTotalRows(res.data.ResponseData[0]?.TotalRecord);
  //         setLoading(false);
  //       })
  //       .catch((err) => {
  //         setLoading(false);
  //       });
  //   }
  // };

  console.log(supplierAccount, "supplieraccount");

  const handleUnSuspend = (pID) => {
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierinformation?supplierid=${pID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res from Suspended Receiving", res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeValue,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  const options = [
    { label: "All", value: 1 },
    { label: "Custom", value: 2 },
    { label: "Last Week", value: 3 },
    { label: "Current Week", value: 4 },
    { label: "Last Month", value: 5 },
    { label: "Current Month", value: 6 },
    { label: "Last 7 Day", value: 7 },
  ];

  const handleChangeCustomStartingDate = (event) => {
    // console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event);
    setStartingDate(event);
  };

  // const handleChangeCustomStartingDate = (selectedDate) => {
  //   if (selectedDate && selectedDate.length > 0) {
  //     const datetime =
  //       moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
  //     const settime = moment(datetime).format("YYYY-MM-DD");
  //     console.log(settime, "settime");
  //     setCustomStartingDate(settime);
  //     setStartingDate(settime);
  //   }
  // };

  // const handleChangeCustomEndingDate = (event) => {
  //   // console.log("event ending ==> ", event.target.value);
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };


  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomEndingDate(selectedDate);
      setEndingDate(selectedDate);
    }
  };


  const handleQuickBookChange = (event) => {
    // event?.value !== 2 && handleSearchAccordingToDate();

    setQuickBookOptions(event);

    console.log(event, "quick book data");


    // All Condition
    if (event?.value == 1) {
      setStartingDate(today);
      setEndingDate(today);
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(today);
      setEndingDate(today);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (event?.value == 7) {
      const startLast7DayDate = moment()
      .subtract(7, "days")
      .startOf("day")
      .format("YYYY-MM-DD");
    const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");
  

      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    }else {
      setStartingDate(today);
      setEndingDate(today);
    }
  };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeValue,
  //     supplierID,
  //     columnFilters,
  //     globalFilter,
  //     pagination,
  //     sorting
  //   );
  // };

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(
  //     page,
  //     newPerPage,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeValue,
  //     supplierID,
  //     columnFilters,
  //     globalFilter,
  //     pagination,
  //     sorting
  //   );
  // };

  // const ChangeFilterText = (e) => {
  //   setSearchText(e.target.value);
  //   setCurrentPage(1);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     e.target.value,
  //     sortingId,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeValue,
  //     supplierID,
  //     columnFilters,
  //     globalFilter,
  //     pagination,
  //     sorting
  //   );
  //   //   console.log("changefilter:------------",handleListData);
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     e.id,
  //     sortingDirection,
  //     startingDate,
  //     endingDate,
  //     receivingTypeValue,
  //     supplierID,
  //     columnFilters,
  //     globalFilter,
  //     pagination,
  //     sorting
  //   );
  // };

  let receivingTypeDropdownOption = [];
  const ReceivingTypeDropdown = rectype.map((u, i) => {
    receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
  });

  const handleChangeReceivingType = (event) => {
    console.log(event?.value, "vvvvvvvvvvvvvvvvvvvvvvvvv");
    setreceivingTypeValue(event?.value);
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      event?.value,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  console.log(receivingTypeValue, "receivingTypeValue550");

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        receivingids: selectedReceivingCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      receivingids: pID || selectedReceivingCheckboxIds,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  // let columns1 = [];

  // if (supplierAccount == 6) {
  //   columns1 = [
  //     {
  //       name: "Sr No",
  //       selector: (row, index) => index + 1,
  //       width: "100px",
  //     },
  //     {
  //       name: "Transaction Date",
  //       selector: (row) =>
  //         moment(row.TransactionDate).format("MM-DD-YYYY HH:mm:ss"),
  //       sortable: true,
  //       // width: "180px",
  //     },

  //     {
  //       name: "Receive Type",
  //       selector: "ReceiveType",
  //       sortable: true,
  //       // width: "120px",
  //     },
  //     {
  //       name: "Amount",
  //       selector: "Amount",
  //       sortable: true,
  //       right: true,
  //       // width: "145px",
  //       Cell: (row) => (
  //         <div
  //           className={
  //             row.TransactionType == "Credit" ? "text-success" : "text-danger"
  //           }
  //         >
  //           {row.Amount}
  //         </div>
  //       ),
  //     },

  //     {
  //       name: "Location",
  //       selector: (row) => row.Location,
  //       sortable: true,
  //       width: "120px",
  //     },
  //     {
  //       name: "Created Date",
  //       selector: (row) =>
  //         moment(row.CreatedDate).format("MM-DD-YYYY HH:mm:ss"),
  //       sortable: true,
  //       // width: "180px",
  //     },
  //     {
  //       name: "CR/DE",
  //       selector: "TransactionType",
  //       sortable: true,
  //       // width: "120px",
  //     },
  //   ];
  // } else if (
  //   receivingTypeValue == 1 ||
  //   receivingTypeValue == 5 ||
  //   receivingTypeValue == 3
  // ) {
  //   columns1 = [
  //     {
  //       name: "Action",
  //       Cell: (row) => (
  //         <div class="btn-group-sm" role="group">
  //           <Link
  //             className="btn btn-primary btn-sm btn-custom-padding"
  //             to={`/manage-receiving/${row.ReceivingId}`}
  //             style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //           >
  //             Edit
  //           </Link>
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           ></button>
  //           <div className="dropdown-menu">
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ID)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>
  //                 &nbsp;Delete Item
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 className="dropdown-item me-3"
  //                 to={`/receiving-receipt/${row.ReceivingId}`}
  //               >
  //                 <i className="fa fa-file"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //           </div>
  //         </div>
  //       ),
  //     },
  //     // {
  //     //   name: "Sr No",
  //     //   selector: (row, index) => index + 1,
  //     // },
  //     {
  //       name: "Date",
  //       selector: (row) => row["Date"],
  //       sortable: true,
  //       width: "130px",
  //     },
  //     {
  //       name: "Receive Type",
  //       selector: (row) => row["ReceiveType"],
  //       sortable: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Status",
  //       selector: (row) => row["StatusName"],
  //       sortable: true,
  //     },
  //     {
  //       name: "Supplier",
  //       // selector: (row) => row["Supplier"],
  //       sortable: true,
  //       width: "150px",
  //       Cell: (row) => (
  //         <Link
  //           class="text-warning word-break-data"
  //           to={`/manage-suppliers/${row.SupplierId}`}
  //         >
  //           {row.Supplier}
  //         </Link>
  //       ),
  //     },
  //     // {
  //     //   name: "Items",
  //     //   selector: (row) => row["Items"],
  //     //   sortable: true,
  //     // },
  //     {
  //       name: "Total",
  //       selector: (row) => row["Total"],
  //       sortable: true,
  //       right: true,
  //     },
  //     // {
  //     //   name: "Amount Paid",
  //     //   selector: (row) => row["AmountPaid"],
  //     //   sortable: true,
  //     //   right: true,
  //     //   width: "150px",
  //     // },
  //     // {
  //     //   name: "Credit Applied",
  //     //   selector: (row) => row["CreditApplied"],
  //     //   sortable: true,
  //     //   right: true,
  //     //   width: "150px",
  //     // },
  //     // {
  //     //   name: "Last Payment Date",
  //     //   selector: row => row["LastPaymentDate"],
  //     //   sortable: true,
  //     // },
  //     // {
  //     //   name: "Amount Due",
  //     //   selector: (row) => row["AmountDue"],
  //     //   sortable: true,
  //     //   right: true,
  //     //   width: "150px",
  //     // },
  //     {
  //       name: "Comments",
  //       // selector: (row) => row["Comments"],
  //       selector: (row) => (
  //         <p className="word-break-data" title={row.Comments}>
  //           {row.Comments}
  //         </p>
  //       ),
  //       width: "200px",
  //     },

  //     {
  //       name: "Location",
  //       // selector: "Location",
  //       selector: (row) => row.Location,
  //       width: "120px",
  //     },
  //     // {
  //     //   name: "Unsuspend",
  //     //   width: "150px",
  //     //   Cell: (row) => {
  //     //     const handleClick = () => {
  //     //       handleUnSuspend(row.ID);
  //     //     };

  //     //     return (row.Status == 1 || row.Status == 2) &&
  //     //       (row.ReceivingTypeId == 1 || row.ReceivingTypeId == 2) ? (
  //     //       <Link to={`/manage-receiving/${row.ReceivingId}`}>
  //     //         <button
  //     //           onClick={handleClick}
  //     //           className={`btn btn-sm btn-outline-${row.Suspended === 1 ? "danger" : "success"
  //     //             }`}
  //     //         >
  //     //           {row.Suspended === 1 ? "Suspend" : "Unsuspend"}
  //     //         </button>
  //     //       </Link>
  //     //     ) : null;
  //     //   },
  //     // },
  //     // {
  //     //   name: "Receipt",
  //     //   width: "150px",
  //     //   Cell: (row) => (
  //     //     <Link
  //     //       className="btn  btn-sm btn-outline-primary"
  //     //       to={`/receiving-receipt/${row.ReceivingId}`}
  //     //     >
  //     //       <i className="fa fa-file"></i> Receipt
  //     //     </Link>
  //     //   ),
  //     // },
  //     // {
  //     //   name: "Action",
  //     //   width: "100px",
  //     //   sortable: false,
  //     //   Cell: (row) => (
  //     //     <>
  //     //       <Link className="me-2" to={`/manage-receiving/${row.ReceivingId}`}>
  //     //         <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //     //       </Link>
  //     //       <Link
  //     //         className="confirm-text"
  //     //         to="#"
  //     //         title="Delete"
  //     //         data-bs-toggle="modal"
  //     //         data-bs-target="#DeleteConfirmationModal"
  //     //         onClick={() => handleDeletePopup(row.ID)}
  //     //       >
  //     //         <i
  //     //           className="fa fa-trash text-red fa-2x"
  //     //           data-bs-toggle="tooltip"
  //     //           title="Delete"
  //     //         ></i>
  //     //       </Link>
  //     //     </>
  //     //   ),
  //     // },
  //   ];
  // } else {
  //   columns1 = [
  //     {
  //       name: "Action",
  //       Cell: (row) => (
  //         <div class="btn-group-sm" role="group">
  //           <Link
  //             className="btn btn-primary btn-sm btn-custom-padding"
  //             to={`/manage-receiving/${row.ReceivingId}`}
  //             style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
  //           >
  //             Edit
  //           </Link>
  //           <button
  //             type="button"
  //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
  //             data-bs-toggle="dropdown"
  //             aria-haspopup="true"
  //             aria-expanded="false"
  //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
  //           ></button>
  //           <div className="dropdown-menu">
  //             <li>
  //               <Link
  //                 className="dropdown-item confirm-text"
  //                 to="#"
  //                 title="Delete"
  //                 data-bs-toggle="modal"
  //                 data-bs-target="#DeleteConfirmationModal"
  //                 onClick={() => handleDeletePopup(row.ID)}
  //               >
  //                 <i
  //                   className="fa fa-trash"
  //                   data-bs-toggle="tooltip"
  //                   title="Delete"
  //                 ></i>
  //                 &nbsp;Delete Item
  //               </Link>
  //             </li>
  //             <li>
  //               <Link
  //                 className="dropdown-item me-3"
  //                 to={`/receiving-receipt/${row.ReceivingId}`}
  //               >
  //                 <i className="fa fa-file"></i>&nbsp;Receipt
  //               </Link>
  //             </li>
  //           </div>
  //         </div>
  //       ),
  //     },
  //     // {
  //     //   name: "Sr No",
  //     //   selector: (row, index) => index + 1,
  //     // },
  //     {
  //       name: "Date",
  //       selector: (row) => row["Date"],
  //       sortable: true,
  //       width: "130px",
  //     },
  //     {
  //       name: "Receive Type",
  //       selector: (row) => row["ReceiveType"],
  //       sortable: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Status",
  //       selector: (row) => row["StatusName"],
  //       sortable: true,
  //     },
  //     {
  //       name: "Supplier",
  //       // selector: (row) => row["Supplier"],
  //       sortable: true,
  //       width: "150px",
  //       Cell: (row) => (
  //         <Link
  //           class="text-warning word-break-data"
  //           to={`/manage-suppliers/${row.SupplierId}`}
  //         >
  //           {row.Supplier}
  //         </Link>
  //       ),
  //     },
  //     // {
  //     //   name: "Items",
  //     //   selector: (row) => row["Items"],
  //     //   sortable: true,
  //     // },
  //     {
  //       name: "Total",
  //       selector: (row) => row["Total"],
  //       sortable: true,
  //       right: true,
  //     },
  //     {
  //       name: "Amount Paid",
  //       selector: (row) => row["AmountPaid"],
  //       sortable: true,
  //       right: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Credit Applied",
  //       selector: (row) => row["CreditApplied"],
  //       sortable: true,
  //       right: true,
  //       width: "150px",
  //     },
  //     // {
  //     //   name: "Last Payment Date",
  //     //   selector: row => row["LastPaymentDate"],
  //     //   sortable: true,
  //     // },
  //     {
  //       name: "Amount Due",
  //       selector: (row) => row["AmountDue"],
  //       sortable: true,
  //       right: true,
  //       width: "150px",
  //     },
  //     {
  //       name: "Comments",
  //       // selector: (row) => row["Comments"],
  //       selector: (row) => (
  //         <p className="word-break-data" title={row.Comments}>
  //           {row.Comments}
  //         </p>
  //       ),
  //       width: "200px",
  //     },

  //     {
  //       name: "Location",
  //       // selector: "Location",
  //       selector: (row) => row.Location,
  //       width: "120px",
  //     },
  //     // {
  //     //   name: "Unsuspend",
  //     //   width: "150px",
  //     //   Cell: (row) => {
  //     //     const handleClick = () => {
  //     //       handleUnSuspend(row.ID);
  //     //     };

  //     //     return (row.Status == 1 || row.Status == 2) &&
  //     //       (row.ReceivingTypeId == 1 || row.ReceivingTypeId == 2) ? (
  //     //       <Link to={`/manage-receiving/${row.ReceivingId}`}>
  //     //         <button
  //     //           onClick={handleClick}
  //     //           className={`btn btn-sm btn-outline-${row.Suspended === 1 ? "danger" : "success"
  //     //             }`}
  //     //         >
  //     //           {row.Suspended === 1 ? "Suspend" : "Unsuspend"}
  //     //         </button>
  //     //       </Link>
  //     //     ) : null;
  //     //   },
  //     // },
  //     // {
  //     //   name: "Receipt",
  //     //   width: "150px",
  //     //   Cell: (row) => (
  //     //     <Link
  //     //       className="btn  btn-sm btn-outline-primary"
  //     //       to={`/receiving-receipt/${row.ReceivingId}`}
  //     //     >
  //     //       <i className="fa fa-file"></i> Receipt
  //     //     </Link>
  //     //   ),
  //     // },
  //     // {
  //     //   name: "Action",
  //     //   width: "100px",
  //     //   sortable: false,
  //     //   Cell: (row) => (
  //     //     <>
  //     //       <Link className="me-2" to={`/manage-receiving/${row.ReceivingId}`}>
  //     //         <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //     //       </Link>
  //     //       <Link
  //     //         className="confirm-text"
  //     //         to="#"
  //     //         title="Delete"
  //     //         data-bs-toggle="modal"
  //     //         data-bs-target="#DeleteConfirmationModal"
  //     //         onClick={() => handleDeletePopup(row.ID)}
  //     //       >
  //     //         <i
  //     //           className="fa fa-trash text-red fa-2x"
  //     //           data-bs-toggle="tooltip"
  //     //           title="Delete"
  //     //         ></i>
  //     //       </Link>
  //     //     </>
  //     //   ),
  //     // },
  //   ];
  // }

  let columns;
  if (supplierAccount == 6) {
    columns = [
      {
        header: "Transaction Date",
        accessorKey: "TransactionDate",
        Cell: ({ row }) =>
          moment(row.original.TransactionDate).format("MM-DD-YYYY HH:mm:ss"),
        // enableGrouping: false, //do not let this column be grouped
      },
      {
        header: "Receive Type",
        accessorKey: "ReceiveType",
        // enableGrouping: false, //do not let this column be grouped
      },
      {
        header: "Amount",
        accessorKey: "Amount",
        // enableGrouping: false, //do not let this column be grouped
        Cell: ({ row }) => (
          <div
            className={
              row.original.TransactionType == "Credit"
                ? "text-success"
                : "text-danger"
            }
          >
            {row.original.Amount}
          </div>
        ),
      },
      {
        header: "Location",
        accessorKey: "Location",
        Cell: ({ row }) => row.original.Location,
      },
      {
        header: "Created Date",
        accessorKey: "CreatedDate",
        Cell: ({ row }) =>
          moment(row.original.CreatedDate).format("MM-DD-YYYY HH:mm:ss"),
        // enableGrouping: false, //do not let this column be grouped
      },
      {
        header: "CR/DE",
        accessorKey: "TransactionType",
        // Cell: ({ row }) => parseFloat(row.original.Total).toFixed(2),
      },
    ];
  } else {
    columns = [
      {
        header: "Receiving / Trans ID",
        accessorKey: "ID",
        size: 150,
        Cell: ({ row }) => (
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight:"700",
              textDecoration:"underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            onClick={() => {
              if (row.original.StatusName === "Opening Balance") {
                navigate(`/manage-suppliers/${row.original.ID}`);
              } else if (
                row.original.ReceivingType === "Bill Payment" &&
                row.original.StatusName !== "-"
              ) {
                navigate(`/receiving-paybills/${row.original.ID}`);
              } else if (
                row?.original?.ReceivingType === "Expense" &&
                row.original.StatusName !== "-"
              ) {
                navigate(`/receiving-receipt/${row.original.ID}`);
              } else if (
                (row.original.ReceivingType === "Vendor Credit"
                  //  ||
                  // "Supplier Return" ||
                  // "Receive"
                ) 
                // &&
                // row.original.StatusName !== "-"
              ) {
                navigate(`/receiving-receipt/${row.original.ID}`);
              }else if(row.original.ReceivingType == "Receive"){
                navigate(`/receiving-receipt/${row.original.ID}`)
              }else if(row.original.ReceivingType == "Journal Entry"){
                navigate(`/journal-entry/${row.original.ID}`)
              } else if (row.original.ReceivingType == "Supplier Return"){
                navigate(`/receiving-receipt/${row.original.ID}`)
              }

            }}
          >
            {row.original.ID}
          </Box>
        ),
      },
      {
        header: "Receiving Date",
        accessorKey: "Date",
        size: 130,
        Cell: ({ row }) => {
          return moment(row.original.Date).format('MM/DD/YYYY h:mm A')
        },
      },
      {
        header: "Type",
        accessorKey: "ReceivingType",
        filterSelectOptions: nemultiselect?.ReceivingType, // ["paid", "unpaid"],
        filterVariant: "multi-select", //"select",
        enableColumnFilterModes: false,
        size: 120,
        Cell: ({ row }) => {
          return row.original.ReceivingType == null
            ? ""
            : row.original.ReceivingType;
        },
      },
      {
        header: "Bill No.",
        accessorKey: "BillNo",
        size: 140,
        Cell: ({ row }) => {
          return row.original.BillNo == 0 ? "" : row.original.BillNo;
        },
        // enableGrouping: false, //do not let this column be grouped
      },
      {
        header: "Payment Type",
        accessorKey: "PaymentType",
        size: 140,
        Cell: ({ row }) => {
          return row.original.PaymentType == null
            ? ""
            : row.original.PaymentType;
        },
      },
      {
        header: "Memo",
        accessorKey: "Memo"
      },
      {
        header: "Due Date",
        accessorKey: "DueDate",
        size: 130,
        Cell: ({ row }) => row.original.DueDate ? moment(row.original.DueDate).format('MM/DD/YYYY') : ''
      },
      {
        header: "Balance",
        accessorKey: "AmountDue",
        Cell: ({ row }) => parseFloat(row.original.AmountDue).toFixed(2),
      },
      {
        header: "Amount",
        accessorKey: "Payment",
        size: 140,
        Cell: ({ row }) => {
          return (
            <>
              {parseFloat(row.original.Payment).toFixed(2)}
              {row.original.Credit == 0 ? (
                ""
              ) : (
                <>
                  <br></br>
                  Credit: {parseFloat(row.original.Credit).toFixed(2)}
                </>
              )}
            </>
          );
        },
      },
      {
        header: "Credit Used",
        accessorKey: "CreditUsed",
        size: 120,
        Cell: ({ row }) => parseFloat(row.original.CreditUsed).toFixed(2),
      },
      {
        header: "Status",
        accessorKey: "StatusName",
        size: 100,
        Cell: ({ row }) => {
          return row.original.StatusName == "Opening Balance"
            ? ""
            : row.original.StatusName;
        },
      },
      {
        header: "Open  Balance",
        accessorKey: "Balance",
        size: 120,
        Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
      },
      {
        header: "QBSyncStatus",
        accessorKey: "SyncStatus",
        size: 120,
        Cell: ({ row }) => {
          if (row.original.SyncStatus === "Complete") {
            return (
              <Box
                component="span"
                sx={(theme) => ({
                  borderRadius: "0.3rem",
                  color: "var(--success-main-color)",
                  maxWidth: "9ch",
                  p: "0.3rem",
                  fontWeight: "bold",
                })}
              >
                {row.original.SyncStatus}
              </Box>
            );
          } else if (
            row.original.SyncStatus === "Failed" &&
            row.original.StatusName !== "Opening Balance"
          ) {
            return (
              <Box
                component="span"
                sx={(theme) => ({
                  borderRadius: "0.3rem",
                  color: "var(--error-main-color)",
                  maxWidth: "9ch",
                  p: "0.3rem",
                  fontWeight: "bold",
                })}
              >
                {row.original.SyncStatus}
              </Box>
            );
          } else if (row.original.StatusName === "Opening Balance") {
            return <span>{row.original.StatusName}</span>;
          } else {
            return null; // Handle other cases if necessary
          }
        },
      },
    ];
  }

  useEffect(() => {
    // if (receivingTypeValue === 1) {
    //   setNewTitle("Purchase Order");
    // }
    // if (receivingTypeValue === 2) {
    //   setNewTitle("Receiving List");
    // }
    // if (receivingTypeValue === 5) {
    //   setNewTitle("Vendor Credit");
    // }
    // if (receivingTypeValue === 3) {
    //   setNewTitle("Supplier Return");
    // }
    // if (receivingTypeValue === 6) {
    // }
    // setNewTitle("Transaction");
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      receivingTypeValue,
      supplierID,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
    // }
  }, [
    supplierID,
    quickBookOptions,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    supplierAccount,
  ]);

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate(today);
      setEndingDate(today);
    }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //current Month
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    }  else if (quickBookOptions?.value == 7) {
      const startLast7DayDate = moment()
      .subtract(7, "days")
      .startOf("day")
      .format("YYYY-MM-DD");
    const endLast7DayDate = moment().endOf("day").format("YYYY-MM-DD");
  

      setStartingDate(startLast7DayDate);
      setEndingDate(endLast7DayDate);
    }else {
      setStartingDate(today);
      setEndingDate(today);
    }
  }, [quickBookOptions]);

  useEffect(() => {
    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("Receving Types", response.data.ResponseData);
        setRectype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // console.log(rectype,"rectype1272")

  const sortData = data?.sort((a, b) => {
    return b?.row_num - a?.row_num;
  });

  // console.log("Response Data:---", data);

  return (
    <>
      <div className="">
        <div className="card bg-white">
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-12">
           <div className="d-flex justify-content-between mt-3 mr-3">
           <h5 className="card-title ml-3 mt-3">
                {supplierAccount == 6 ? "Wallet Logs" : "Transaction"}
              </h5>
              <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    style={{ borderRadius: "5px", padding: "8px" }}
                    onClick={() => navigate("/suppliers")}
                  >
                    Back
                  </button>
           </div>
              <hr />
              <div className="d-flex  flex-direction-col flex-wrap ml-3">
                {/* <div className="p-2 col-lg-3 col-md-6 col-sm-12">
                  Search:
                  <input
                    type="search"
                    placeholder="Search..."
                    className="form-control form-control-sm"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  ></input>
                </div> */}

                <div className="p-2 col-lg-3 col-md-6 col-sm-12">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    // isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>

                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-2 col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}
                      <CommonDatePicker FinalDate={startingDate} handleDateChange={handleChangeCustomStartingDate}/>
                    </div>
                    <div className="p-2 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      {/* <Flatpickr
                        type="date"
                        className="form-control"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                             options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                      /> */}
                       <CommonDatePicker FinalDate={endingDate} handleDateChange={handleChangeCustomEndingDate}/>
                    </div>
                    <div className="p-4 mt-1 col-lg-2 col-md-6 col-sm-12">
                      <button
                        className="btn btn-dark"
                        onClick={() => handleSearchAccordingToDate()}
                      >
                        {" "}
                        Search{" "}
                      </button>
                    </div>
                  </>
                )}

                {supplierAccount === 4 && (
                  <div className="p-2 col-lg-3 col-md-6 col-sm-12">
                    Receiving Type:
                    <Select
                      defaultValue={receivingTypeValue}
                      onChange={(event) => {
                        handleChangeReceivingType(event);
                      }}
                      options={receivingTypeDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col mb-9">
              <div className="card-body">
                <div style={{position:"relative", zIndex:'0'}}>
                  {/* <DataTable
                    title={newTitle}
                    columns={columns1}
                    data={data}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    onChangePage={handlePageChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[25, 50, 100, 500]}
                    persistTableHead
                    sortServer
                    onSort={handleSort}
                    contextActions={contextActions}
                    clearSelectedRows={toggleCleared}
                    dense
                    paginationPerPage={perPageSize}
                  /> */}

                  <MaterialReactTable
                    columns={columns}
                    data={sortData}
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    // enableRowSelection
                    enableColumnOrdering
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    initialState={{
                      density: "comfortable",
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      sorting: [{ id: "Date", desc: false }], //sort by Date by default
                      columnVisibility: {
                        SyncStatus: false,
                        StatusName:false,
                        CreditUsed:false,
                        // Payment:false,
                        // AmountDue:false,
                        DueDate:false, 
                        Balance:false, 
                        PaymentType:false, 
                      },
                    }}
                    // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                    // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                    //For color of each alternative row(Zebra-column)
                    muiTableBodyProps={{
                      sx: () => ({
                        "& tr:nth-of-type(even)": {
                          backgroundColor: "rgb(237 237 233 / 63%)",
                        },
                      }),
                    }}
                    muiPaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300, 500],
                    }}
                    // For providing color to header of table
                    muiTableHeadCellProps={{
                      sx: (theme) => ({
                        background: "#e9e9e9",
                        borderRight: "1px solid rgba(224,224,224,1)",
                      }),
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                      isError
                        ? {
                            color: "error",
                            children: "Error loading data",
                          }
                        : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={totalRows}
                    state={{
                      columnFilters,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}

                    // renderTopToolbarCustomActions={({ table }) => (
                    //   <Box
                    //     sx={{
                    //       display: "flex",
                    //       gap: "1rem",
                    //       p: "0.5rem",
                    //       flexWrap: "wrap",
                    //     }}
                    //   >
                    //     <Button size="small"
                    //       color="primary"
                    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    //       onClick={onBtExport}
                    //       startIcon={<FileDownloadIcon />}
                    //       variant="contained"
                    //     >
                    //       Export All In Excel
                    //     </Button>
                    //     <Button size="small"
                    //       disabled={
                    //         !table.getIsSomeRowsSelected() &&
                    //         !table.getIsAllRowsSelected()
                    //       }
                    //       //only export selected rows
                    //       onClick={() =>
                    //         handleExportRows(table.getSelectedRowModel().rows)
                    //       }
                    //       startIcon={<FileDownloadIcon />}
                    //       variant="contained"
                    //     >
                    //       Export Selected Rows in Excel
                    //     </Button>
                    //     <Button size="small"
                    //       color="primary"
                    //       //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    //       onClick={downloadPDF("", "alldata")}
                    //       startIcon={<FileDownloadIcon />}
                    //       variant="contained"
                    //     >
                    //       Export All In Pdf
                    //     </Button>
                    //     <Button size="small"
                    //       disabled={
                    //         !table.getIsSomeRowsSelected() &&
                    //         !table.getIsAllRowsSelected()
                    //       }
                    //       //only export selected rows
                    //       onClick={() =>
                    //         downloadPDF(table.getSelectedRowModel().rows, "selectedrow")
                    //       }
                    //       startIcon={<FileDownloadIcon />}
                    //       variant="contained"
                    //     >
                    //       Export Selected Rows in Pdf
                    //     </Button>
                    //   </Box>
                    // )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupplierEditData;
